import { STORAGE_KEYS } from '~constants'

const getMetadata = () => {
  const metadata = localStorage.getItem(STORAGE_KEYS.CONSULTATION_METADATA)
  return metadata
}

export default getMetadata
